<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.companyname" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpname" :label="item.ccorpname" :value="item.ccorpname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料名称">
          <el-input v-model="formInline.cinvname" placeholder="物料名称"></el-input>
        </el-form-item>

        <el-form-item label="入库日期">
          <el-date-picker v-model="formInline.ddeliverytime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetBilledList" size="medium">查询</el-button>
          </Debounce>
          <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
          <el-button type="primary" size="medium" @click="handleExport()">无税收分类EXCEL导出</el-button>
        </el-form-item>
        <div style="color: red;padding-bottom: 20px;">
        提示：如无税收分类，将无法提交发票，请联系采购人员，及时维护税收分类与开票物料描述对照。
      </div>
      </el-form>
  
      <div class="text item text-center">
        <!-- <div class="pull-right" style="margin-bottom:15px">
          <el-button type="success" size="medium">新增</el-button>
          <el-button size="medium">编辑</el-button>
          <el-button type="danger" size="medium">删除</el-button>
          <el-button type="primary" size="medium">提交</el-button>
          <el-button type="danger" plain size="medium">撤销提交</el-button>
          <el-button type="warning" size="medium" plain>打印</el-button>
        </div> -->
        <el-table :data="tableData" style="width: 100%" id="out-table" class="tablecenter" show-summary :summary-method="getSummaries" :row-class-name="tableRowClassName" border :cell-style="{ padding: '7px 0'}" :header-cell-style="{ background: '#eef1f6' }">
          <!-- <el-table-column prop="iinport" label="提交状态" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.iinport==1">已提交</span>
              <span v-if="scope.row.iinport==0">未提交</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="companyname" label="牧场名称" width="180"></el-table-column> -->
          <el-table-column prop="ccorpname" label="公司名称" width="180"></el-table-column>
          <el-table-column prop="cordercode" label="订单号" width="100"></el-table-column>
          <el-table-column prop="crkcode" label="入库号" width="100"></el-table-column>
          <el-table-column prop="ctaxationcode" label="税收分类" width="160"></el-table-column>
          <el-table-column prop="ctaxationname" label="供应商开票物料描述" width="180"></el-table-column>
          <!-- <el-table-column prop="cvenname" label="供应商名称" width="180"></el-table-column> -->
          <el-table-column prop="cinvname" label="物料描述" width="280"></el-table-column>
          <el-table-column prop="csapinvcode" label="物料编码" width="160"></el-table-column>
          <el-table-column prop="cinvmodel" label="规格" width="100"></el-table-column>
          <el-table-column prop="cunit" label="计量单位" width="100"></el-table-column>
          <el-table-column prop="drkdate" label="入库日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.drkdate"> {{scope.row.drkdate.substring(0,10)}}</span>

            </template>
          </el-table-column>
          <!-- <el-table-column prop="iorderqty" label="订单数量" width="80"></el-table-column> -->
          <el-table-column prop="inumber" label="待开票数量" width="100"></el-table-column>
          <el-table-column prop="ifpnumber" label="已开票数量" width="100"></el-table-column>
          <el-table-column prop="iprice" label="单价" width="80"></el-table-column>
          <!-- <el-table-column prop="itaxe" label="税率" width="80"></el-table-column> -->

          <el-table-column prop="ijfmoney" label="奖惩金额" width="100"></el-table-column>
          <el-table-column prop="itoltalmoney" label="含税金额" width="100"></el-table-column>
          <el-table-column prop="izlkk" label="其他综合扣款" width="100"></el-table-column>
          <!-- <el-table-column prop="ipaymoneypiao" label="开票金额" width="100"></el-table-column> -->
          <el-table-column prop="ikpmoney" label="开票金额" width="100"></el-table-column>
          <!-- <el-table-column prop="ModifyUserName" label="变更人" width="120"></el-table-column>
          <el-table-column prop="ModifyDate" label="变更时间" width="120"></el-table-column> -->
          <!-- <el-table-column  label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="read(scope.row)">查看</el-button>
        </template>
       </el-table-column> -->
        </el-table>
        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      formInline: {
        companyname: "",
        cpoid: "",
        cinvname: "",
        ddeliverytime: "",
      },
      tableData: [],
      // 牧场
      selectlist: {},
      // 分页
      pageSize: 10,
      pageIndex: 1,
      // 页数
      totalCount: 0,
    };
  },
  created() {
    this.GetBilledList();
    this.GetAccountInfo();
  },
  methods: {
    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
        raw: true,
      });
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "待开发票.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    /** 导出按钮操作 */
    handleExport () {
      var date=this.parseTime(new Date())
      console.log(date)
      var dataform={
        type:"export-0001"
      }
      // this.download('/CommonModule/Op_Supplier/SupplierExportExcelPC', dataform, `无税收分类EXCEL_${date}.xlsx`);
      this.$axios({
        method: "post",
        url: "/CommonModule/Op_Supplier/SupplierExportExcelPC",
        data: dataform,
      }).then((res) => {
        console.log(res);
        if(res.data.Success){
          this.down(res.data.Data)
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
      // 下载
      down (url) {
        if (url != "") {
          // 根据浏览地址下载文件;
          const a = document.createElement("a");
          let urlblob = this.global.bxiosdow + url;
          // console.log(urlblob);
          // window.open(urlblob);
          fetch(urlblob)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              a.href = URL.createObjectURL(blob);
              console.log(a.href);
              a.download = "无税收分类"; // 下载文件的名字
              document.body.appendChild(a);
              a.click();
            });
        } else {
          this.$message.error("暂无文件");
        }
      },
        //是否版本变更，是变换行颜色
        tableRowClassName({ row }) {
      console.log(row, "获取信息结果");
      // if (row.cversionup == "是") {
      //   return "success-row";
      // }
      if (row.itaxation !== 1) {
        return "success-row";
      }
      return "";
    },
    // 求和
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));

        if (
          index ==10 ||
          index == 11 ||
          index == 12 ||
          index == 13 ||
          index == 14 ||
          index == 15 ||
          index == 16
        ) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr).toFixed(2);;
              if (!isNaN(value)) {
                return Number((Number(prev) +Number(curr)).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2));
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },
    // 获取table 信息
    GetBilledList() {
      console.log(this.formInline);
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }

      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetBilledList",
        //data: this.formInline,
        data: {
          startDate: starttime,
          endDate: endtime,
          ccorpname: this.formInline.companyname,
          cinvname: this.formInline.cinvname,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Data.rows) {
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        }
      });
    },
    // 获取公司信息
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    onSubmit() {
      console.log("submit!");
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBilledList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetBilledList();
    },
  },
};
</script>
<style>
  .el-table .success-row {
    background: #59ff00;
  }
</style>

